import * as wjcCore from '@grapecity/wijmo';
import * as wjMultirow from '@grapecity/wijmo.grid.multirow';
import * as wjInput from 'wijmo/wijmo.input';
import * as uuid from 'uuid';

declare var Stimulsoft: any;

'use strict';

import {HostListener, ViewChild, Component, AfterViewInit} from '@angular/core';
import {Store} from "@ngrx/store";
import {ToasterService} from "angular2-toaster";
import {DayPilot, DayPilotCalendarComponent, DayPilotMonthComponent} from "daypilot-pro-angular";
import {KaitoriyaConfig} from "../config/kaitoriya.config";
import {asOrientDate, isOrientDate, DataService, OrientDBCollectionView} from "@cosbeni/database";
import {ConfirmComponent} from "../ui/modal";
import {ActivatedRoute, Router} from "@angular/router";
import {ModalDirective} from "ngx-bootstrap/modal";
import {LoadUserAction} from "../ngrx/actions/user.action";
import {SetUuidAction} from "../ngrx/actions/order.action";

@Component({
    selector: 'cj-user-calendar',
    templateUrl: 'calendar.component.html',
})

export class CalendarComponent implements AfterViewInit {
    readonly: Boolean = true;
    @ViewChild("dayCalendar", {static: false}) dayCalendar: DayPilotCalendarComponent;
    @ViewChild("weekCalendar", {static: false}) weekCalendar: DayPilotCalendarComponent;
    @ViewChild("monthCalendar", {static: false}) monthCalendar: DayPilotMonthComponent;
    @ViewChild('modal') public modal: ModalDirective;
    @ViewChild('orderLineGrid') orderLineGrid: wjMultirow.MultiRow;
    keyword: string = "";
    orderLineDefinition: any;
    events: any[] = [];
    screenWidth: number;
    classifications: any[] = [];
    departments: any[] = [];
    orderHead: any = {};
    orders: any[] = [];
    orderLine: wjcCore.CollectionView = new wjcCore.CollectionView([]);
    mode: string = "day";
    configNavi = {
        locale: "ja-jp",
        selectMode: "day",
        showMonths: 1,
        skipMonths: 1
    };
    calendarDate = DayPilot.Date.today();
    configDay = {
        startDate: DayPilot.Date.today(),
        locale: "ja-jp",
        viewType: "Day",
        eventDeleteHandling: "Disabled",
        eventMoveHandling: "Disabled",
        eventResizeHandling: "Disabled",
        eventDoubleClickHandling: "Enabled",
        onEventDeleted: args => {
        },
        onEventMoved: args => {
        },
        onEventResized: args => {
        },
        onEventClicked: args => {
            for (let order of this.orders) {
                if (order.uuid == args.e.data.id) {
                    this.orderHead = order;
                    this.loadOrderLine(order['@rid']);
                    this.modal.show();
                    break;
                }
            }
        },
        onEventDoubleClick: args => {},
        onTimeRangeSelected: args => {},
        onBeforeEventRender: function (args) {
            args.data.html = args.data.text + " (" + args.data.tags.title + ")";
        }
    };
    configWeek = {
        startDate: DayPilot.Date.today(),
        locale: "ja-jp",
        viewType: "Week",
        eventDeleteHandling: "Disabled",
        eventMoveHandling: "Disabled",
        eventResizeHandling: "Disabled",
        eventDoubleClickHandling: "Enabled",
        onEventDeleted: args => {
        },
        onEventMoved: args => {
        },
        onEventResized: args => {
        },
        onEventClicked: args => {
            for (let order of this.orders) {
                if (order.uuid == args.e.data.id) {
                    this.orderHead = order;
                    this.loadOrderLine(order['@rid']);
                    this.modal.show();
                    break;
                }
            }
        },
        onEventDoubleClick: args => {},
        onTimeRangeSelected: args => {
        },
        onBeforeEventRender: function (args) {
            args.data.html = args.data.text + " (" + args.data.tags.title + ")";
        }
    };
    configMonth = {
        startDate: DayPilot.Date.today(),
        locale: "ja-jp",
        eventDeleteHandling: "Disabled",
        eventMoveHandling: "Disabled",
        eventResizeHandling: "Disabled",
        eventDoubleClickHandling: "Enabled",
        onEventDeleted: args => {
        },
        onEventMoved: args => {
        },
        onEventResized: args => {
        },
        onEventClicked: args => {
            for (let order of this.orders) {
                if (order.uuid == args.e.data.id) {
                    this.orderHead = order;
                    this.loadOrderLine(order['@rid']);
                    this.modal.show();
                    break;
                }
            }
        },
        onEventDoubleClick: args => {},
        onTimeRangeSelected: args => {
        },
        onBeforeEventRender: function (args) {
            args.data.html = args.data.text + " (" + args.data.tags.title + ")";
        }
    };

    constructor(public store: Store<any>, public dataService: DataService, public toasterService: ToasterService, public router: Router) {
        this.resizeScreen();
        this.dataService.query({
            sql: "SELECT FROM AP_Master WHERE category ='買取区分' order by sort",
            count: "SELECT FROM AP_Master WHERE category ='買取区分' order by sort",
            fetchPlan: "*:1",
        }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.classifications = data.results;
            }
        })
        this.dataService.query({
            sql: "SELECT FROM AP_Master WHERE category ='部門' order by sort",
            count: "SELECT FROM AP_Master WHERE category ='部門' order by sort",
            fetchPlan: "*:1",
        }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.departments = data.results;
            }
        })
        this.configDay.onEventDoubleClick = function (args) {
            for (let order of this.orders) {
                if (order.uuid == args.e.data.id) {
                    this.store.dispatch(new SetUuidAction(order.uuid));
                    this.router.navigate(["user/order"], {});
                }
            }
        }.bind(this);
        this.configWeek.onEventDoubleClick = function (args) {
            for (let order of this.orders) {
                if (order.uuid == args.e.data.id) {
                    this.store.dispatch(new SetUuidAction(order.uuid));
                    this.router.navigate(["user/order"], {});
                }
            }
        }.bind(this);
        this.configMonth.onEventDoubleClick = function (args) {
            for (let order of this.orders) {
                if (order.uuid == args.e.data.id) {
                    this.store.dispatch(new SetUuidAction(order.uuid));
                    this.router.navigate(["user/order"], {});
                }
            }
        }.bind(this);
    }

    ngAfterViewInit() {
    }

    changeDate(date: DayPilot.Date): void {
        this.configDay.startDate = date;
        this.configWeek.startDate = date;
        this.configMonth.startDate = date;
    }

    //@HostListener('window:resize', ['$event'])
    resizeScreen(event?) {
        this.screenWidth = window.innerWidth;
        if (this.screenWidth >= 768) {
            this.orderLineDefinition =
                [
                    {
                        cells: [
                            {binding: 'productName', header: '商品名', width: 160},
                        ]
                    },
                    {
                        cells: [
                            {binding: 'manufactureName', header: 'メーカー', width: 160},
                        ]
                    },
                    {
                        cells: [
                            {binding: 'modelNumber', header: '型番', width: 160},
                        ]
                    },
                    {
                        cells: [
                            {binding: 'quantity', header: '数量', dataType: 'Number', width: 80},
                        ]
                    },
                    {
                        cells: [
                            {binding: 'unit', header: '単位', width: 40},
                        ]
                    },
                    {
                        cells: [
                            {binding: 'price', header: '単価', dataType: 'Number', width: 80},
                        ]
                    },
                    {
                        cells: [
                            {binding: 'amount', header: '金額', dataType: 'Number', width: 80, isReadOnly: true},
                        ]
                    },
                    {
                        cells: [
                            {binding: 'memo', header: '備考', width: 320},
                        ]
                    },
                ];
        } else {
            this.orderLineDefinition =
                [
                    {
                        colspan: 3,
                        cells: [
                            {binding: 'productName', header: '商品名', width: 100, colspan: 2},
                            {binding: 'unit', header: '単位', width: 100},
                            {binding: 'manufactureName', header: 'メーカー', colspan: 2},
                            {binding: 'quantity', header: '数量', dataType: 'Number'},
                            {binding: 'modelNumber', header: '型番', colspan: 2},
                            {binding: 'price', header: '単価', dataType: 'Number'},
                            {binding: 'memo', header: '備考', colspan: 2},
                            {binding: 'amount', header: '金額', dataType: 'Number', isReadOnly: true},
                        ]
                    }
                ];
        }
    }

    viewChange() {
        let where = [];
        let startDate = new Date(this.calendarDate.toDateLocal().getFullYear(), this.calendarDate.toDateLocal().getMonth(), 1);
        let endDate = new Date(this.calendarDate.toDateLocal().getFullYear(), this.calendarDate.toDateLocal().getMonth() + 1, 1);
        where.push("(startDate >= '" + wjcCore.Globalize.formatDate(startDate, 'yyyy-MM-dd HH:mm:ss') + "' AND startDate < '" + wjcCore.Globalize.formatDate(endDate, 'yyyy-MM-dd HH:mm:ss') + "')");
        this.dataService.query({
            sql: "SELECT FROM AP_Order_HEAD WHERE " + where.join(" AND "),
            count: "SELECT FROM AP_Order_HEAD WHERE " + where.join(" AND "),
            fetchPlan: "*:1",
        }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
            this.events = []
            for (let item of data.results) {
                if (isOrientDate(item.orderDate)) {
                    item.orderDate = asOrientDate(item.orderDate);
                }
                if (isOrientDate(item.startDate)) {
                    item.startDate = asOrientDate(item.startDate);
                }
                if (isOrientDate(item.endDate)) {
                    item.endDate = asOrientDate(item.endDate);
                }
                if (isOrientDate(item.birthDay)) {
                    item.birthDay = asOrientDate(item.birthDay);
                }
                let address = "";
                if (!wjcCore.isNullOrWhiteSpace(item.state)) {
                    address = address + item.state;
                }
                if (!wjcCore.isNullOrWhiteSpace(item.city)) {
                    address = address + item.city;
                }
                if (!wjcCore.isNullOrWhiteSpace(item.street)) {
                    address = address + item.street;
                }
                if (!wjcCore.isNullOrWhiteSpace(item.building)) {
                    address = address + item.building;
                }
                item.address = address;
                this.events.push({
                    start: new DayPilot.Date(item.startDate, true),
                    end: new DayPilot.Date(item.endDate, true),
                    id: item.uuid,
                    text: item.name,
                    tags: {"title": item.address},
                    bubbleHtml: item.memo
                })
            }
            this.orders = data.results;
        })
    }

    loadOrderLine(rid: string): void {
        this.dataService.query({
            sql: "SELECT FROM AP_Order_Line WHERE header = " + rid + " ORDER BY sort",
            count: "SELECT FROM AP_Order_Line WHERE header = " + rid + " ORDER BY sort",
            fetchPlan: "*:1",
        }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
            this.orderLine.sourceCollection = wjcCore.asArray(data.results);
            this.orderLine.refresh();
        })
    }

    previous() {
        if (this.mode == "day") {
            this.calendarDate = this.calendarDate.addDays(-1);
        }
        if (this.mode == "week") {
            this.calendarDate = this.calendarDate.addDays(-7);
        }
        if (this.mode == "month") {
            this.calendarDate = this.calendarDate.addMonths(-1);
        }
    }

    next() {
        if (this.mode == "day") {
            this.calendarDate = this.calendarDate.addDays(1);
        }
        if (this.mode == "week") {
            this.calendarDate = this.calendarDate.addDays(7);
        }
        if (this.mode == "month") {
            this.calendarDate = this.calendarDate.addMonths(1);
        }
    }

    editOrder(){
        this.store.dispatch(new SetUuidAction(this.orderHead.uuid));
        this.router.navigate(["user/order"], {});
    }

}

